module.exports = "/static/media/polaris@2x.78fe5012.png";